import { useState, useEffect, useRef } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { useSelector } from "react-redux/es/exports";
import { selectTempOrder } from "../../Order/orderSlice";
import StripeCheckoutForm from "./StripeCheckoutForm";
import "./Stripe.css";

// Load Stripe
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

export default function StripeCheckout() {
  const [clientSecret, setClientSecret] = useState("");
  const order = useSelector(selectTempOrder);

  const hasFetched = useRef(false);

  useEffect(() => {
    if (!hasFetched.current) {
      hasFetched.current = true; // Mark as called immediately

      fetch(`${process.env.REACT_APP_BACKEND_URL}/create-payment-intent`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(order),
      })
        .then((res) => res.json())
        .then((data) => setClientSecret(data.clientSecret))
        .catch((err) => {
          console.error("Payment Intent Error:", err);
          hasFetched.current = false; // Agar fail ho jaye to retry allow
        });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const appearance = {
    theme: 'stripe',
    variables: {
      colorPrimary: '#4f46e5',
      colorBackground: '#ffffff',
      colorText: '#30313d',
      colorDanger: '#df1b41',
      fontFamily: 'Ideal Sans, system-ui, sans-serif',
      spacingUnit: '4px',
      borderRadius: '8px',
    },
    rules: {
      '.Tab': {
        border: '1px solid #E0E6EB',
        boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.03), 0px 3px 6px rgba(18, 42, 66, 0.02)',
      },
    }
  };

  const options = {
    clientSecret,
    appearance,
  };

  return (
    <div className="bg-white flex flex-col justify-start pb-28 pt-16 px-4 sm:px-6 lg:px-8">

      <div className="w-full max-w-md mx-auto text-center mb-6">
        <h2 className="text-3xl font-extrabold text-gray-900">Secure Payment</h2>
        <p className="mt-2 text-sm text-gray-600">
          Complete your purchase securely with Stripe.
        </p>
      </div>

      <div className="w-full max-w-md mx-auto">
        <div className="bg-gray-100 w-full py-8 mx-auto px-6 shadow rounded-lg sm:px-10 border border-gray-100">
          {clientSecret ? (
            <Elements options={options} stripe={stripePromise}>
              <StripeCheckoutForm />
            </Elements>
          ) : (
            <div className="flex justify-center items-center h-40">
              <div className="spinner"></div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}